import { render, staticRenderFns } from "./PaperIcon.vue?vue&type=template&id=3f98bfae&"
import script from "./PaperIcon.vue?vue&type=script&lang=ts&"
export * from "./PaperIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports